"use strict";

const style = require('!!css-loader?{"sourceMap":false}!postcss-loader!./style/index.css').default;

module.exports =`
    <style>${style}</style>
    <div class="swiftref-input">
        <div style="display: flex; align-items: center;"><label></label></div>
        <div class="input-container">
            <input>
        </div>
        <swiftref-message></swiftref-message> 
    </div>
`;
